import { create } from 'zustand'
import type { ManualGradeCredit } from '@/types/coaching'

export type GradingDraft = Readonly<Record<string, ManualGradeCredit>>
export const EMPTY_GRADING_DRAFT: GradingDraft = {}

interface GradingDraftState {
  drafts: Record<string, GradingDraft>
  update: (scope: string, updater: (draft: GradingDraft) => GradingDraft) => void
  clearRow: (scope: string, quizId: string) => void
  clear: () => void
}

/** Memory only: remounts retain drafts; a reload starts a fresh session. */
export const useGradingDraftStore = create<GradingDraftState>((set, get) => ({
  drafts: {},
  update: (scope, updater) => set((state) => {
    const current = state.drafts[scope] ?? EMPTY_GRADING_DRAFT
    const next = updater(current)
    if (next === current) return state
    const drafts = { ...state.drafts }
    if (Object.keys(next).length) drafts[scope] = next
    else delete drafts[scope]
    return { drafts }
  }),
  clearRow: (scope, quizId) => get().update(scope, (draft) => {
    if (draft[quizId] === undefined) return draft
    const next = { ...draft }
    delete next[quizId]
    return next
  }),
  clear: () => set({ drafts: {} }),
}))
